import React from 'react'
import PropTypes from 'prop-types'
import ModeEdit from 'material-ui/svg-icons/editor/mode-edit'

const listData = (
  fname,
  lname,
  email,
  phone,
  id,
  attribution,
  otherAttribution,
  handleContactEdit,
) => ([
  <span key="fname" className="contactFirstName"> {fname} </span>,
  <span key="lname" className="contactLastName">{lname}</span>,
  <span key="email" className="contactEmail">{email}</span>,
  <span key="phone" className="contactPhone">{phone}</span>,
  <button
    key="contactEdit"
    className="contactEdit"
    onClick={() => handleContactEdit(fname, lname, email, phone, id, attribution, otherAttribution)}
  >
    <ModeEdit />
  </button>,
])

const ContactRow = ({
  first_name: firstName,
  last_name: lastName,
  email,
  formatPhoneNumber,
  phone_number: phoneNumber,
  id,
  attribution,
  other_attribution: otherAttribution,
  handleContactEdit,
}) => (
  <li className="contactsRow">
    <div className="contactsRowLink">
      {listData(
        firstName,
        lastName,
        email,
        formatPhoneNumber(phoneNumber),
        id,
        attribution,
        otherAttribution,
        handleContactEdit,
      )}
    </div>
  </li>
)

ContactRow.propTypes = {
  phone_number: PropTypes.string,
  email: PropTypes.string,
  first_name: PropTypes.string,
  formatPhoneNumber: PropTypes.func.isRequired,
  last_name: PropTypes.string,
  id: PropTypes.number,
  attribution: PropTypes.string,
  other_attribution: PropTypes.string,
  handleContactEdit: PropTypes.func,
}

export default ContactRow



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/Row.js